import './footer.css';
import logo from '../../assets/images/logo.png';


const Footer = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    return (
        <div className="constainerFooter">
            <div className="divider"></div>
            <div className="containerContact flex pl-4 md:pl-48 pt-20 pb-20">
                <img src={logo} className='logo mr-3 md:mr-7' alt="Logo Empresa"/>
                <div className='flex text-white' >
                    <div className='divisorVertical mr-5'></div>
                    <div>
                        <strong className='md:text-2xl'>Tels: 01 (999) 942 09 00 | 01 800 20 10 500</strong>
                        <p>Proteínas y Oleicos {currentYear}, Todos los derechos reservados ®</p>
                        <a href='documents/politicas_de_privacidad.pdf' target='_blank' className='text-sm politicaPrivacidad'>Políticas de privacidad</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
